export default {
  articles: [],
  article: undefined,
};
